export default "__VITE_ASSET__DwehhKyV__"